import { device } from "../Utils/device.js";

export default class Hud {
    constructor({ onRestart }) {
        this.onRestart = onRestart;
        this.lastDepth = -1;
        this.lastHealth = -1;
        this.lastStormText = "";

        this.root = document.createElement("div");
        this.root.innerHTML = `
            <div id="hud-top">
                <div class="hud-col">
                    <div class="hud-card">
                        <div>下潜深度：<b id="depth-val">0</b> 米</div>
                        <div class="hud-sub" id="storm-timer">沙尘暴 30s</div>
                    </div>
                </div>
                <div class="hud-col right">
                    <div class="hud-card" id="health-box">生命值：<b id="health-val">100</b>/100</div>
                    <button class="mini-btn" id="btn-fullscreen" type="button">全屏</button>
                </div>
            </div>
            <div id="storm-warning">⚠ 沙尘暴来袭 —— 快躲进坑里！</div>
            <div id="vignette"></div>
            <div id="hint">WASD / 方向键 移动　·　空格 挖掘　·　拖动鼠标旋转视角　·　R 重开</div>
            <div id="touch-controls">
                <div id="dpad">
                    <button class="dpad-btn" data-dir="up" type="button">▲</button>
                    <button class="dpad-btn" data-dir="left" type="button">◀</button>
                    <button class="dpad-btn" data-dir="right" type="button">▶</button>
                    <button class="dpad-btn" data-dir="down" type="button">▼</button>
                </div>
                <div id="action-area">
                    <button id="btn-reset" type="button" aria-label="重新开始">↺</button>
                    <button id="btn-dig" type="button" aria-label="挖掘">挖</button>
                </div>
            </div>
            <div id="center-overlay">
                <h1 id="center-title">任务成功！</h1>
                <p id="center-sub"></p>
                <button id="center-btn" type="button">再来一次</button>
            </div>
        `;
        document.body.appendChild(this.root);

        this.depthVal = this.root.querySelector("#depth-val");
        this.healthVal = this.root.querySelector("#health-val");
        this.stormTimer = this.root.querySelector("#storm-timer");
        this.vignette = this.root.querySelector("#vignette");
        this.warning = this.root.querySelector("#storm-warning");
        this.overlay = this.root.querySelector("#center-overlay");
        this.title = this.root.querySelector("#center-title");
        this.sub = this.root.querySelector("#center-sub");
        this.hint = this.root.querySelector("#hint");
        this.restartBtn = this.root.querySelector("#center-btn");
        this.fullscreenBtn = this.root.querySelector("#btn-fullscreen");

        if (device.isTouchDevice) {
            this.hint.textContent =
                "左下方向键移动 · 右下「挖」挖掘 · 拖动屏幕旋转视角";
        }

        this.restartBtn.addEventListener("click", (event) => {
            event.stopPropagation();
            this.onRestart();
        });

        this.bindFullscreen();
    }

    bindFullscreen() {
        const button = this.fullscreenBtn;

        button.addEventListener("click", (event) => {
            event.stopPropagation();
            const doc = document;
            const root = doc.documentElement;

            if (!doc.fullscreenElement && !doc.webkitFullscreenElement) {
                const request =
                    root.requestFullscreen ||
                    root.webkitRequestFullscreen ||
                    root.webkitRequestFullScreen ||
                    root.mozRequestFullScreen ||
                    root.msRequestFullscreen;
                if (request) {
                    try {
                        request.call(root);
                    } catch (err) {
                        // Fullscreen can be rejected without a user gesture on some browsers.
                    }
                }
            } else {
                const exit =
                    doc.exitFullscreen ||
                    doc.webkitExitFullscreen ||
                    doc.mozCancelFullScreen ||
                    doc.msExitFullscreen;
                if (exit) {
                    try {
                        exit.call(doc);
                    } catch (err) {
                        // Ignore exit failures when fullscreen is already closing.
                    }
                }
            }
        });

        const sync = () => {
            const full = !!(
                document.fullscreenElement || document.webkitFullscreenElement
            );
            button.textContent = full ? "退出" : "全屏";
        };

        document.addEventListener("fullscreenchange", sync);
        document.addEventListener("webkitfullscreenchange", sync);
        sync();
    }

    update({ depth, health, stormActive, stormLeft, stormTimer, stormIntensity }) {
        if (depth !== this.lastDepth) {
            this.depthVal.textContent = depth;
            this.lastDepth = depth;
        }

        const shownHealth = Math.max(0, Math.ceil(health));
        if (shownHealth !== this.lastHealth) {
            this.healthVal.textContent = shownHealth;
            this.lastHealth = shownHealth;
        }

        let text;
        if (stormActive) {
            text = "⚠ 沙尘暴 " + Math.max(0, Math.ceil(stormLeft)) + "s";
            this.stormTimer.className = "hud-sub alarm";
        } else {
            text = "沙尘暴 " + Math.max(0, Math.ceil(stormTimer)) + "s";
            this.stormTimer.className = "hud-sub";
        }

        if (text !== this.lastStormText) {
            this.stormTimer.textContent = text;
            this.lastStormText = text;
        }

        this.vignette.style.opacity = stormIntensity;
        this.warning.classList.toggle("show", stormActive);
    }

    showResult({ failed, title, sub }) {
        this.title.classList.toggle("fail", failed);
        this.title.textContent = title;
        this.sub.textContent = sub;
        this.overlay.classList.add("show");
        this.hint.style.opacity = "0";

        this.title.style.animation = "none";
        void this.title.offsetWidth;
        this.title.style.animation = "";
    }

    hideResult() {
        this.overlay.classList.remove("show");
        this.hint.style.opacity = "";
        this.lastDepth = -1;
        this.lastHealth = -1;
        this.lastStormText = "";
    }
}
